import { Checkbox } from "shared";
import {
    ITemplateComponent,
    ITemplateTextComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import styles from "./component_form_text.module.scss";

interface IComponentFormTextProps {
    component: ITemplateTextComponent;
    componentList: ITemplateComponent[];
    enLanguageEnabled: boolean;
    onChange: (component: ITemplateComponent) => void;

}

export const ComponentFormText: React.FC<IComponentFormTextProps> = React.memo(({
                                                                                    component,
                                                                                    componentList,
                                                                                    enLanguageEnabled,
                                                                                    onChange
                                                                                }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplateTextComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formText")}
                    name="name-dynamic-input"
                    onChange={onFieldChange}/>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <Checkbox
            label={t("rowGroup")}
            className={styles.checkbox}
            size="m"
            onChange={() => onFieldChange({ isRowGroup: !component.isRowGroup })}
            checked={component.isRowGroup}
        />
    </div>
});
